<template>
  <div>
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        单据基本信息
      </div>
      <div class="rj-page-card__content">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                单据编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ query.contractNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                标题：
              </div>
              <div class="rj-baseinfo__item">
                {{ query.projectName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                客户名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ query.clientName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ query.applicantTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                单据金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ query.orderAmount }}元
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ query.amountAllocated }}元
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配比例：
              </div>
              <div class="rj-baseinfo__item">
                {{ query.distributionRatio? query.distributionRatio:0 }}%
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                未分配金额：
              </div>
              <div class="rj-baseinfo__item">
                {{ query.unallocatedAmount }}元
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h4>款项分配</h4>
    <div class="tableBody">
      <el-form :inline="true">
        <el-form-item label="电汇单编号:">
          <el-input v-model="searchForm.telegraphicTransferNum" clearable placeholder="电汇单编号" />
        </el-form-item>
        <el-form-item label="汇款金额:">
          <el-input-number
            v-model="searchForm.minRemittanceAmount"
            :controls="false"
            :precision="2"
            :min="0"
            placeholder="最小金额"
            class="input-width"
          />
          <span>-</span>
          <el-input-number
            v-model="searchForm.maxRemittanceAmount"
            :controls="false"
            :precision="2"
            :min="0"
            placeholder="最大金额"
            class="input-width"
          />
        </el-form-item>
        <el-form-item label="汇款日期:">
          <el-date-picker
            v-model="searchForm.rangeDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            clearable
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            class="tange-date-width"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="isSearchLoading" @click="doSearch">
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <el-table
        v-loadmore="handleScroll"
        v-loading="tableLoading"
        :data="tableData"
        border
        style="width: 100%"
        height="400"
      >
        <el-table-column fixed type="index" width="50" label="序号" align="left" />
        <el-table-column prop="telegraphicTransferNum" label="电汇底单编号" align="left" width="200px" fixed />
        <el-table-column prop="remittanceAmount" label="汇款金额" align="right" header-align="left" min-width="120" />
        <el-table-column prop="remittanceDate" label="汇款日期" align="left" width="150px" />
        <el-table-column prop="importAccount" label="汇入账户" align="left" min-width="120" />
        <el-table-column prop="importCompany" label="汇入公司" align="left" min-width="140" />
        <el-table-column prop="summary" label="摘要" align="left" />
        <el-table-column prop="usedAmount" label="已使用金额（元）" min-width="120" align="right" header-align="left" />
        <el-table-column prop="unusedAmount" label="可用余额（元）" min-width="120" align="right" header-align="left" />
        <el-table-column prop="assignAmount" label="本次分配金额（元）" min-width="130" align="right" header-align="left">
          <template v-slot="{row}">
            <el-input-number v-model="row.assignAmount" style="width:100%;" :precision="2" :min="0" label="描述文字" @change="assignBlur(row)" />
          </template>
        </el-table-column>
        <div slot="append" class="append-wrap">
          <span v-if="isShowAppend">
            <i class="el-icon-loading icon" />
            <span>加载中...</span>
          </span>
          <span v-else-if="!isShowAppend && tableData.length">
            加载完成
          </span>
        </div>
      </el-table>
    </div>
    <el-button type="primary" style="margin-top:20px" @click="sureAAllocation">
      分配
    </el-button><span>
      本次分配金额：<span class="money">{{ assignAllTotal }} 元</span>
    </span>
    <sureAAllocation :dialog-form-visible="dialogFormVisible" :data="sureData" @on-status-dialog="updataDialogFormVisible" />
  </div>
</template>

<script>
import { selectAssignInfoByUserCodeOrContractNum } from '@/API/index.js';
import { MathAdd, debounce } from '@/libs/util';
import sureAAllocation from './sureAAllocation';
export default {
  data () {
    return {
      query: this.$route.query,
      dialogFormVisible: false,
      loading: false,
      tableData: [],
      tableLoading: false,
      sureData: {
        dialogData: [],
        contractType: '',
        contractId: 0
      },

      searchForm: {},
      isSearchLoading: false,

      // 下拉加载完毕
      isLoadCompleted: false,

      pageData: {
        pageIndex: 1,
        pageSize: 50,
        total: 0
      }
    };
  },
  components: {
    sureAAllocation
  },
  mounted () {
    this.initData();
  },
  computed: {
    assignAllTotal () {
      let total = 0;
      this.tableData.forEach((item) => {
        total = MathAdd(item.assignAmount ? item.assignAmount : 0, total);
      });
      return total;
    },
    // 是否显示触底 loading
    isShowAppend () {
      if (this.isLoadCompleted) {
        return false;
      } else {
        return this.pageData.total > this.tableData.length;
      }
    }
  },
  methods: {
    // 格式化回款日期
    formatRangeDate (array) {
      if (array && array[0] && array[1]) {
        return { beginRemittanceDate: array[0], endRemittanceDate: array[1] };
      } else {
        return {};
      }
    },

    // 搜索的按钮
    async doSearch () {
      this.pageData.pageIndex = 1;

      let params = {
        contractNum: this.$route.query.contractNum,
        userName: this.$route.query.clientName,
        pageIndex: this.pageData.pageIndex,
        pageSize: this.pageData.pageSize,
        telegraphicTransferNum: this.searchForm.telegraphicTransferNum,
        minRemittanceAmount: this.searchForm.minRemittanceAmount,
        maxRemittanceAmount: this.searchForm.maxRemittanceAmount,
        ...this.formatRangeDate(this.searchForm.rangeDate)
      };

      this.isSearchLoading = true;
      selectAssignInfoByUserCodeOrContractNum(params)
        .then(res => {
          this.isSearchLoading = false;
          let { status, data } = res.data;
          if (status === '200') {
            if (data.list.length) {
              data.list.forEach((item) => (item.assignAmount = 0));
              this.tableData = data.list;
              this.pageData.total = data.total;
              this.isLoadCompleted = false;
            } else {
              this.tableData = [];
              this.pageData.total = 0;
              this.isLoadCompleted = true;
            }
          }
        })
        .catch(() => {
          this.isSearchLoading = false;
        });
    },

    // 触底加载更多
    handleScroll: debounce(function () {
      if (this.pageData.total > this.tableData.length) {
        ++this.pageData.pageIndex;
      } else {
        this.isLoadCompleted = true;
        return false;
      }

      let params = {
        contractNum: this.$route.query.contractNum,
        userName: this.$route.query.clientName,
        pageIndex: this.pageData.pageIndex,
        pageSize: this.pageData.pageSize,
        telegraphicTransferNum: this.searchForm.telegraphicTransferNum,
        minRemittanceAmount: this.searchForm.minRemittanceAmount,
        maxRemittanceAmount: this.searchForm.maxRemittanceAmount,
        ...this.formatRangeDate(this.searchForm.rangeDate)
      };

      selectAssignInfoByUserCodeOrContractNum(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          if (data.list.length) {
            data.list.forEach((item) => (item.assignAmount = 0));
            this.tableData.push(...data.list);
            this.pageData.total = data.total;
          } else {
            this.isLoadCompleted = true;
          }
        }
      });
    }),

    initData () {
      let params = {
        contractNum: this.$route.query.contractNum,
        userName: this.$route.query.clientName,
        pageIndex: this.pageData.pageIndex,
        pageSize: this.pageData.pageSize,
        telegraphicTransferNum: this.searchForm.telegraphicTransferNum,
        minRemittanceAmount: this.searchForm.minRemittanceAmount,
        maxRemittanceAmount: this.searchForm.maxRemittanceAmount,
        ...this.formatRangeDate(this.searchForm.rangeDate)
      };

      this.tableLoading = true;
      selectAssignInfoByUserCodeOrContractNum(params).then((res) => {
        this.tableLoading = false;
        let { status, data } = res.data;
        if (status === '200') {
          if (data.list.length) {
            data.list.forEach((item) => (item.assignAmount = 0));
            this.tableData = data.list;
            this.pageData.total = data.total;
          } else {
            this.isLoadCompleted = true;
          }
        }
      }).catch((res) => {
        this.tableLoading = false;
      });
    },
    sureAAllocation () {
      this.sureData.dialogData = JSON.parse(JSON.stringify(this.tableData));
      this.sureData.dialogData.forEach((item) => {
        item.contractNum = this.query.contractNum;
        item.amountSum = this.query.orderAmount;
      });
      // 过滤本次分配金额不为0 的
      let resData = this.sureData.dialogData.filter((item) => {
        return item.assignAmount > 0;
      });
      this.sureData.dialogData = resData;
      this.dialogFormVisible = true;
    },
    // 组件事件
    updataDialogFormVisible (val) {
      this.dialogFormVisible = val;
    },
    assignBlur (row) {
      if (row.unusedAmount < row.assignAmount) {
        this.$nextTick(() => {
          row.assignAmount = row.unusedAmount;
        });
      }
      let num = 0;
      this.tableData.forEach((item) => {
        if (item.assignAmount > 0) {
          num = num + item.assignAmount;
        }
      });
      if (num > this.query.unallocatedAmount) {
        this.$notify.warning('本次分配金额不能大于未分配金额，请进行调整');
        this.$nextTick(() => {
          row.assignAmount = 0;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tange-date-width{
  width: 240px;
}

.append-wrap{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;

  .icon{
     font-size: 16px;
  }
}
</style>
